import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as MessageStore from './message.state';
import { contactAdapter } from './message.adapters';
import { selectContactId } from './message.adapters';
import { MessageModels } from '../../../interfaces';

export const selectFeature =
  createFeatureSelector<MessageStore.State>('messageState');

export const selectContactsState = createSelector(
  selectFeature,
  (state) => state.contacts,
);

export const selectContacts = createSelector(
  selectContactsState,
  contactAdapter.getSelectors().selectAll,
);

export const selectContactsTotal = createSelector(
  selectContactsState,
  contactAdapter.getSelectors().selectTotal,
);

export const selectRecipients = createSelector(
  selectFeature,
  (state) => state.recipients,
);

export const selectRecipientsTotal = createSelector(
  selectRecipients,
  (recipients) => recipients.length,
);

export const selectRecipientsVM = createSelector(
  selectRecipients,
  (recipients) =>
    recipients.map<MessageModels.RecipientVM>((recipient) => ({
      label: `${recipient.firstName} ${recipient.lastName}`,
    })),
);

export const selectContactsVM = createSelector(
  selectContacts,
  selectRecipients,
  (contacts, recipients) => {
    const recipientIds = recipients.map((recipient) =>
      selectContactId(recipient),
    );
    return contacts
      .filter((contact) => !recipientIds.includes(selectContactId(contact)))
      .map<MessageModels.ContactVM>((contact) => ({
        id: contact.userID,
        firstName: contact.firstName,
        lastName: contact.lastName,
        fullName: `${contact.firstName} ${contact.lastName}`,
        hotelName: contact.hotelName!,
        position: contact.position!,
        isManager: contact.userType === 'webUser',
        isActivated:
          contact.userStatus === 'activated' ||
          contact.userStatus === 'Activated',
      }));
  },
);
